import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, timeout } from 'rxjs';
import { IWordpressCategory } from 'src/app/models/wordpress.category.interface';
import { environment } from 'src/environments/environment';

@Injectable()
export class WordpressService {
  private apiUrl: string = `${environment.apiUrl}/wordpress`;

  constructor(private http: HttpClient) {}

  /**
   * Get Wordpress categories
   * @returns Array of wordpress categories
   */
  getCategories(accountId: string): Observable<IWordpressCategory[]> {
    const url = `${this.apiUrl}/categories/${accountId}`;
    return this.http.get<IWordpressCategory[]>(url);
  }

  /**
   * Force refresh WordPress categories on the server (clears cache then fetches)
   */
  refreshCategories(accountId: string): Observable<IWordpressCategory[]> {
    // Add a cache-busting query param to avoid intermediate caching (CDN/proxy/browser)
    const url = `${this.apiUrl}/categories/${accountId}/refresh?t=${Date.now()}`;
    const headers = new HttpHeaders({ 'Cache-Control': 'no-cache', Pragma: 'no-cache' });
    return this.http.get<IWordpressCategory[]>(url, { headers });
  }


  getWordpressStatus(url: string): Observable<any> {
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'text/plain' }), // Optional headers
    };
    return this.http
    .get(url, { ...options, responseType: 'text' as const })
    .pipe(
      timeout(5000),
      catchError((err) => {
        console.error('WordPress site check failed:', err);
        return of(null); 
      })
    )
  }
}
